import React from "react";
import { useTranslation } from "react-i18next";
import { GetUserInfo } from "../../../utils/permissionChecker";
import { formatDate, calculateExperience } from "../../../utils/date_utils";
import { Link } from "react-router-dom";
import { Col, Row, Container, Table } from "react-bootstrap";
import Card from "../../../components/Card";
import user1 from "../../../assets/images/user/1.jpg";
import { useQuery } from "@tanstack/react-query";
import {
  get_employee,
  get_employeeDetail,
} from "../../../services/employeeApi";
const UserProfile = () => {
  const { t } = useTranslation();
  const user = GetUserInfo();
  const emp_id = user.emp_id;
  const getUserQuery = useQuery(["get_user_profile"], () =>
    get_employee(emp_id)
  );
  const getUserDetailQuery = useQuery(["get_user_detail"], () =>
    get_employeeDetail(emp_id)
  );

  if (getUserQuery.isLoading || getUserDetailQuery.isLoading) {
    return <div>Loading...</div>;
  }
  if (getUserQuery.isError) {
    return <div>Error: {getUserQuery.error.message}</div>;
  }
  if (getUserDetailQuery.isError) {
    return <div>Error: {getUserDetailQuery.error.message}</div>;
  }
  const myProfile = getUserQuery.data;
  const myDetail = getUserDetailQuery.data;
  console.log(myProfile);
  return (
    <>
      <Container fluid>
        <Row>
          <Col lg="4">
            <Card className="card-block p-card">
              <div className="profile-box">
                <div className="profile-card rounded">
                  <img
                    src={user1}
                    alt="profile-bg"
                    className="avatar-100 rounded d-block mx-auto img-fluid mb-3"
                  />
                  <h4 className="font-400 text-white text-center mb-0">
                    {myProfile.first_name} {myProfile.father_name}
                  </h4>
                  <p className="text-white text-center mb-5">
                    {myProfile.employment_type}{" "}
                  </p>
                </div>
                <div className="pro-content rounded">
                  <div className="d-flex align-items-center mb-3">
                    <div className="p-icon mr-3">
                      <i className="las la-map-marked"></i>
                    </div>
                    <p className="mb-0">{myProfile.department}</p>
                  </div>
                  <div className="d-flex align-items-center mb-3">
                    <div className="p-icon mr-3">
                      <i className="las la-phone"></i>
                    </div>
                    <p className="mb-0">{user.employee.phone}</p>
                  </div>
                  <div className="d-flex align-items-center mb-3">
                    <div className="p-icon mr-3">
                      <i className="las la-envelope-open-text"></i>
                    </div>
                    <p className="mb-0 eml">{user.employee.email}</p>
                  </div>
                  <div className="d-flex justify-content-center">
                    <div className="social-ic d-inline-flex rounded">
                      <Link to="#">
                        <i className="fab fa-facebook-f"></i>
                      </Link>
                      <Link to="#">
                        <i className="fab fa-twitter"></i>
                      </Link>
                      <Link to="#">
                        <i className="fab fa-youtube"></i>
                      </Link>
                      <Link to="#">
                        <i className="fab fa-pinterest-p"></i>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </Card>
            <Row>
              {/* <Col sm="4" lg="12">
                            <Card className="card-block card-stretch card-height">
                                <Card.Body className="text-center">
                                    <svg width="36" height="48" viewBox="0 0 36 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                        d="M9.10495 33.9964C8.29026 33.1817 8.71495 33.4114 6.74995 32.8855C5.85838 32.6464 5.07463 32.1871 4.36588 31.6367L0.112441 42.0655C-0.299122 43.0752 0.469629 44.1721 1.559 44.1308L6.4987 43.9424L9.8962 47.5311C10.6462 48.3224 11.9624 48.0758 12.374 47.0661L17.2537 35.1017C16.2375 35.668 15.1096 35.9999 13.9434 35.9999C12.1153 35.9999 10.3978 35.2883 9.10495 33.9964V33.9964ZM35.8875 42.0655L31.634 31.6367C30.9253 32.188 30.1415 32.6464 29.25 32.8855C27.2746 33.4142 27.7078 33.1836 26.895 33.9964C25.6021 35.2883 23.8837 35.9999 22.0556 35.9999C20.8893 35.9999 19.7615 35.6671 18.7453 35.1017L23.625 47.0661C24.0365 48.0758 25.3537 48.3224 26.1028 47.5311L29.5012 43.9424L34.4409 44.1308C35.5303 44.1721 36.299 43.0742 35.8875 42.0655V42.0655ZM24.6562 31.8749C26.0887 30.4171 26.2528 30.5427 28.2928 29.9867C29.595 29.6314 30.6131 28.5955 30.9618 27.2699C31.6631 24.6074 31.4812 24.9289 33.3946 22.9808C34.3481 22.0105 34.7203 20.5958 34.3715 19.2702C33.6712 16.6096 33.6703 16.9808 34.3715 14.3174C34.7203 12.9917 34.3481 11.5771 33.3946 10.6067C31.4812 8.65862 31.6631 8.97925 30.9618 6.31768C30.6131 4.99206 29.595 3.95612 28.2928 3.60081C25.679 2.88737 25.994 3.07393 24.0787 1.12487C23.1253 0.154558 21.735 -0.225129 20.4328 0.130183C17.82 0.842683 18.1846 0.843621 15.5671 0.130183C14.2649 -0.225129 12.8746 0.153621 11.9212 1.12487C10.0078 3.073 10.3228 2.88737 7.70807 3.60081C6.40588 3.95612 5.38776 4.99206 5.03901 6.31768C4.33869 8.97925 4.51963 8.65862 2.60619 10.6067C1.65275 11.5771 1.27963 12.9917 1.62932 14.3174C2.32963 16.9761 2.33057 16.6049 1.62932 19.2692C1.28057 20.5949 1.65275 22.0096 2.60619 22.9808C4.51963 24.9289 4.33776 24.6074 5.03901 27.2699C5.38776 28.5955 6.40588 29.6314 7.70807 29.9867C9.8062 30.5586 9.96276 30.4686 11.3437 31.8749C12.584 33.1377 14.5162 33.3636 16.0068 32.4205C16.6029 32.0421 17.2944 31.8411 18.0004 31.8411C18.7065 31.8411 19.3979 32.0421 19.994 32.4205C21.4837 33.3636 23.4159 33.1377 24.6562 31.8749ZM9.15557 16.4961C9.15557 11.5246 13.1156 7.49425 18 7.49425C22.8843 7.49425 26.8443 11.5246 26.8443 16.4961C26.8443 21.4677 22.8843 25.498 18 25.498C13.1156 25.498 9.15557 21.4677 9.15557 16.4961V16.4961Z"
                                        fill="#4788ff" />
                                    </svg>
                                    <h2 className="mb-2 mt-3 text-primary">42+</h2>
                                    <h4>Awards</h4>
                                </Card.Body>
                            </Card>
                            </Col> */}
              <Col sm="4" lg="12">
                <Card className="card-block card-stretch card-height">
                  <Card.Body className="text-center">
                    <svg
                      width="60"
                      height="48"
                      viewBox="0 0 60 48"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M23.9091 24.5297C24.495 25.1156 25.4447 25.1156 26.0306 24.5297L27.0909 23.4694C27.6769 22.8834 27.6769 21.9338 27.0909 21.3478L23.7422 18L27.09 14.6512C27.6759 14.0653 27.6759 13.1156 27.09 12.5297L26.0297 11.4694C25.4437 10.8834 24.4941 10.8834 23.9081 11.4694L18.4387 16.9387C17.8528 17.5247 17.8528 18.4744 18.4387 19.0603L23.9091 24.5297V24.5297ZM32.91 23.4703L33.9703 24.5306C34.5563 25.1166 35.5059 25.1166 36.0919 24.5306L41.5613 19.0613C42.1472 18.4753 42.1472 17.5256 41.5613 16.9397L36.0919 11.4703C35.5059 10.8844 34.5563 10.8844 33.9703 11.4703L32.91 12.5306C32.3241 13.1166 32.3241 14.0662 32.91 14.6522L36.2578 18L32.91 21.3488C32.3241 21.9347 32.3241 22.8844 32.91 23.4703V23.4703ZM58.5 39H35.7694C35.7 40.8572 34.3903 42 32.7 42H27C25.2478 42 23.9044 40.3622 23.9278 39H1.5C0.675 39 0 39.675 0 40.5V42C0 45.3 2.7 48 6 48H54C57.3 48 60 45.3 60 42V40.5C60 39.675 59.325 39 58.5 39ZM54 4.5C54 2.025 51.975 0 49.5 0H10.5C8.025 0 6 2.025 6 4.5V36H54V4.5ZM48 30H12V6H48V30Z"
                        fill="#37e6b0"
                      />
                    </svg>
                    <h2 className="mb-2 mt-3 text-success">
                      {calculateExperience(myProfile.hire_date)}
                    </h2>
                    <h4>Experience</h4>
                  </Card.Body>
                </Card>
              </Col>
              <Col sm="4" lg="12">
                <Card className="card-block card-stretch card-height">
                  <Card.Body className="text-center">
                    <svg
                      width="48"
                      height="48"
                      viewBox="0 0 48 48"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M35.3676 11.2517C34.8398 11.2372 34.3256 11.3198 33.8438 11.4898V7.03125C33.8438 4.70503 31.9512 2.8125 29.625 2.8125C29.0759 2.8125 28.5517 2.91909 28.0701 3.11072C27.5821 1.32047 25.9428 0 24 0C22.0572 0 20.4179 1.32047 19.9299 3.11072C19.4483 2.91909 18.9241 2.8125 18.375 2.8125C16.0488 2.8125 14.1562 4.70503 14.1562 7.03125V11.4895C13.6747 11.3198 13.1607 11.2372 12.6324 11.2517C10.3711 11.3136 8.53125 13.2316 8.53125 15.5272V48H36.6562V41.2395L38.5637 36.4704C39.1643 34.9689 39.4688 33.3877 39.4688 31.7705V15.5272C39.4688 13.2316 37.6289 11.3136 35.3676 11.2517V11.2517ZM11.3438 45.1875V42.375H33.8438V45.1875H11.3438ZM36.6562 31.7705C36.6562 33.0283 36.4194 34.2581 35.9523 35.4261L34.2979 39.5625H11.3438V15.5272C11.3438 14.7405 11.9564 14.0837 12.7095 14.0631C13.0926 14.0504 13.4561 14.1937 13.7305 14.4607C14.0051 14.7278 14.1563 15.0858 14.1563 15.4687V21.9843H16.9688V7.03125C16.9688 6.25584 17.5997 5.625 18.3751 5.625C19.1505 5.625 19.7813 6.25584 19.7813 7.03125V21.9844H22.5938V4.21875C22.5938 3.44334 23.2247 2.8125 24.0001 2.8125C24.7755 2.8125 25.4063 3.44334 25.4063 4.21875V21.9844H28.2188V7.03125C28.2188 6.25584 28.8497 5.625 29.6251 5.625C30.4005 5.625 31.0313 6.25584 31.0313 7.03125V24.1714C24.712 24.8732 19.7812 30.2467 19.7812 36.75H22.5938C22.5938 31.3222 27.0097 26.9062 32.4375 26.9062H33.8438V15.4688C33.8438 15.0859 33.995 14.7278 34.2696 14.4608C34.544 14.1938 34.9067 14.0508 35.2906 14.0632C36.0436 14.0838 36.6562 14.7406 36.6562 15.5273V31.7705Z"
                        fill="#fe721c"
                      />
                    </svg>
                    <h2 className="mb-2 mt-3 text-warning">4+</h2>
                    <h5>Project Participated</h5>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Col>
          <Col lg="8">
            <Card className="card-block">
              <Card.Header>
                <Card.Header.Title>
                  <h4 className="card-title mb-0">About Me</h4>
                </Card.Header.Title>
              </Card.Header>
              <Card.Body>
                <p></p>
                <h5 className="mb-2">Personal Address</h5>
                {myProfile.employee_address ? (
                  <ul className="list-unstyled mb-0">
                    <li className="mb-3">
                      <i className="fa fa-check-circle text-primary fa-lg mr-2"></i>
                      {myProfile.employee_address.region}(
                      {myProfile.employee_address.country})
                    </li>
                    <li className="mb-3">
                      <i className="fa fa-check-circle text-primary fa-lg mr-2"></i>
                      National Id: {myProfile.tin_number}
                    </li>
                  </ul>
                ) : (
                  ""
                )}
              </Card.Body>
            </Card>
            <Card className="card-block">
              <Card.Header>
                <Card.Header.Title>
                  <h4 className="card-title">Education Traning</h4>
                </Card.Header.Title>
              </Card.Header>
              <Card.Body>
                <ul className="list-inline p-0 m-0">
                  {myProfile.emp_educations.map((item, index) => {
                    return (
                      <li
                        key={item.id}
                        className="d-flex align-items-center mb-3"
                      >
                        <div className="profile-icon mm-icon-box rounded-small bg-danger-light svg-danger text-center">
                          {index % 2 === 0 ? (
                            <svg
                              width="24"
                              height="28"
                              viewBox="0 0 24 28"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M17.1107 17.1746L12 22.2853L6.88929 17.1746C3.05893 17.3406 0 20.4746 0 24.3424V24.8567C0 26.2764 1.15179 27.4281 2.57143 27.4281H21.4286C22.8482 27.4281 24 26.2764 24 24.8567V24.3424C24 20.4746 20.9411 17.3406 17.1107 17.1746ZM0.728571 4.27457L1.07143 4.35493V7.4835C0.696429 7.7085 0.428571 8.09957 0.428571 8.571C0.428571 9.021 0.675 9.396 1.02321 9.62636L0.1875 12.9639C0.0964286 13.3335 0.3 13.7139 0.594643 13.7139H2.83393C3.12857 13.7139 3.33214 13.3335 3.24107 12.9639L2.40536 9.62636C2.75357 9.396 3 9.021 3 8.571C3 8.09957 2.73214 7.7085 2.35714 7.4835V4.66564L5.89286 5.51743C5.43214 6.43886 5.14286 7.46743 5.14286 8.571C5.14286 12.3585 8.2125 15.4281 12 15.4281C15.7875 15.4281 18.8571 12.3585 18.8571 8.571C18.8571 7.46743 18.5732 6.43886 18.1071 5.51743L23.2661 4.27457C24.2411 4.03886 24.2411 2.82278 23.2661 2.58707L13.0661 0.122784C12.3696 -0.0432879 11.6357 -0.0432879 10.9393 0.122784L0.728571 2.58171C-0.241071 2.81743 -0.241071 4.03886 0.728571 4.27457Z"
                                fill="#6074F9"
                              />
                            </svg>
                          ) : (
                            <svg
                              width="24"
                              height="20"
                              viewBox="0 0 24 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <g clipPath="url(#clip0)">
                                <path
                                  d="M23.3379 5.745L12.8777 2.53125C12.3077 2.35612 11.6927 2.35612 11.1231 2.53125L0.662429 5.745C-0.220321 6.01612 -0.220321 7.18349 0.662429 7.45462L2.48605 8.01487C2.08593 8.50949 1.83993 9.11287 1.81555 9.77362C1.45443 9.98062 1.20018 10.3541 1.20018 10.8C1.20018 11.2042 1.41318 11.5444 1.71993 11.7619L0.762554 16.0699C0.679304 16.4445 0.964304 16.8 1.34793 16.8H3.45205C3.83605 16.8 4.12105 16.4445 4.0378 16.0699L3.08043 11.7619C3.38718 11.5444 3.60018 11.2042 3.60018 10.8C3.60018 10.3661 3.35755 10.0031 3.01293 9.79237C3.04143 9.22912 3.32943 8.73112 3.7888 8.41537L11.1227 10.6687C11.4624 10.773 12.1142 10.9031 12.8773 10.6687L23.3379 7.45499C24.2211 7.1835 24.2211 6.0165 23.3379 5.745V5.745ZM13.2298 11.8159C12.1599 12.1444 11.2483 11.9629 10.7702 11.8159L5.33193 10.1452L4.80018 14.4C4.80018 15.7256 8.02368 16.8 12.0002 16.8C15.9767 16.8 19.2002 15.7256 19.2002 14.4L18.6684 10.1449L13.2298 11.8159V11.8159Z"
                                  fill="#FF4B4B"
                                />
                              </g>
                              <defs>
                                <clipPath id="clip0">
                                  <rect width="24" height="19.2" fill="white" />
                                </clipPath>
                              </defs>
                            </svg>
                          )}
                        </div>
                        <div className="ml-3">
                          <h5>
                            {item.education_level} of {item.major_field}
                          </h5>
                          <p className="mb-0">
                            {item.educational_institution}
                            {formatDate(item.from_date)}-
                            {formatDate(item.graduation_year)}
                          </p>
                        </div>
                      </li>
                    );
                  })}
                </ul>
              </Card.Body>
            </Card>
            <Card className="card-block">
              <Card.Header>
                <Card.Header.Title>
                  <h4 className="card-title">Past Experience</h4>
                </Card.Header.Title>
              </Card.Header>
              <Card.Body>
                <ul className="list-inline p-0 m-0">
                  {myProfile.emp_experiences.map((item) => {
                    return (
                      <li
                        key={item.id}
                        className="d-flex align-items-center mb-3"
                      >
                        <div className="profile-icon mm-icon-box rounded-small bg-danger-light svg-danger text-center">
                          <svg
                            width="24"
                            height="26"
                            viewBox="0 0 24 26"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M23.25 6.46152V7.26922C23.25 7.37632 23.2105 7.47904 23.1402 7.55478C23.0698 7.63051 22.9745 7.67306 22.875 7.67306H21.75V8.27883C21.75 8.61337 21.4981 8.8846 21.1875 8.8846H2.8125C2.50186 8.8846 2.25 8.61337 2.25 8.27883V7.67306H1.125C1.02554 7.67306 0.930161 7.63051 0.859835 7.55478C0.789509 7.47904 0.75 7.37632 0.75 7.26922V6.46152C0.750001 6.38163 0.772007 6.30353 0.813234 6.2371C0.854462 6.17068 0.913058 6.11892 0.981609 6.08837L11.8566 1.64606C11.9484 1.60512 12.0516 1.60512 12.1434 1.64606L23.0184 6.08837C23.0869 6.11892 23.1455 6.17068 23.1868 6.2371C23.228 6.30353 23.25 6.38163 23.25 6.46152V6.46152ZM22.125 21.8077H1.875C1.25367 21.8077 0.75 22.3501 0.75 23.0192V23.8269C0.75 23.934 0.789509 24.0367 0.859835 24.1125C0.930161 24.1882 1.02554 24.2308 1.125 24.2308H22.875C22.9745 24.2308 23.0698 24.1882 23.1402 24.1125C23.2105 24.0367 23.25 23.934 23.25 23.8269V23.0192C23.25 22.3501 22.7463 21.8077 22.125 21.8077ZM4.5 9.69229V19.3846H2.8125C2.50186 19.3846 2.25 19.6558 2.25 19.9904V21H21.75V19.9904C21.75 19.6558 21.4981 19.3846 21.1875 19.3846H19.5V9.69229H16.5V19.3846H13.5V9.69229H10.5V19.3846H7.5V9.69229H4.5Z"
                              fill="#FE721C"
                            />
                          </svg>
                        </div>
                        <div className="ml-3">
                          <h5>{item.employer}</h5>
                          <p className="mb-0">
                            {item.position} | {formatDate(item.from_date)} -{" "}
                            {formatDate(item.to_date)}
                          </p>
                        </div>
                      </li>
                    );
                  })}
                </ul>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default UserProfile;
